<!-- 积分明细 -->
<template>
    <div class="jifenDetailPage">
      <!-- header start -->
      <van-nav-bar
        title="积分明细"
        fixed
        :placeholder="true"
        :z-index="99"
        left-arrow
        @click-left="goBack"
      />
      <!-- header end -->
  
      <div v-if="viewModel != null" class="tongji-section">
        <div class="col">
          <div class="tongji-box">
            <div class="price-box">
              ￥
              <span class="price">{{
                viewModel.MemberIntegralApi.IncomeTotalIntegral
              }}</span>
            </div>
            <div class="des">收入</div>
          </div>
        </div>
        <div class="col">
          <div class="tongji-box">
            <div class="price-box">
              ￥
              <span class="price">{{
                viewModel.MemberIntegralApi.PayTotalIntegral
              }}</span>
            </div>
            <div class="des">支出</div>
          </div>
        </div>
        <!-- <div class="col">
          <div class="tongji-box">
            <div class="price-box">
              ￥
              <span class="price">{{
                viewModel.memberIntegral.frozenTotalIntegral
              }}</span>
            </div>
            <div class="des">冻结积分</div>
          </div>
        </div> -->
      </div>
  
      <div class="selectdate-box" @click="jifenDateShow = true">
        <div class="lable-box">
          <img src="~@/assets/images/clock-icon.png" alt="" class="icon" />
          <span class="title">日期</span>
        </div>
        <div class="input-control">{{ date }}</div>
        <van-icon name="arrow" size="12" color="#999" />
      </div>
  
      <div class="jifen-box">
        <van-tabs
          v-model="tabActive"
          sticky
          z-index="999"
          offset-top="46"
          :border="false"
          :swipe-threshold="4"
          background="#ffffff"
          color="#f3354f"
          line-height="4px"
        >
          <van-tab title="全部">
            <JifenItem :readType="-1" :beginTime="beginTime" :endTime="endTime" ></JifenItem>
            <!-- <div class="nohave">已经到底了~</div> -->
          </van-tab>
          <van-tab title="收入">
            <JifenItem :readType="1" :beginTime="beginTime" :endTime="endTime"></JifenItem>
            <!-- <div class="nodata-box">
              <img src="~@/assets/image/NOdata.png" alt="" class="thumb" />
              <div class="tips">哎呀~该页面暂无记录哦</div>
            </div> -->
          </van-tab>
          <van-tab title="支出">
            <JifenItem :readType="2" :beginTime="beginTime" :endTime="endTime"></JifenItem>
            <!-- <div class="nodata-box">
              <img src="~@/assets/image/NOdata.png" alt="" class="thumb" />
              <div class="tips">哎呀~该页面暂无记录哦</div>
            </div> -->
          </van-tab>
        </van-tabs>
      </div>
  
      <!-- 日历 popup start -->
      <van-calendar
        v-model="jifenDateShow"
        type="range"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
      />
      <!-- 日历 popup end -->
    </div>
  </template>
  
  <script>
  import { Calendar } from "vant";
  import common from "../../../tools/common";
  import JifenItem from "../../../components/JifenItem.vue";
  
  export default {
    data() {
      return {
        date: "",
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(),
        currentDate: new Date(),
        jifenDateShow: false,
        tabActive: 0,
        viewModel: null,
        beginTime:"",
        endTime:""
      };
    },
    components: {
      [Calendar.name]: Calendar,
      JifenItem
    },
    methods: {
      init() {
        this.getTotal();
      },
      getTotal() {
        var that = this;
        that.$store
          .dispatch({
            type: "MemberIntegralTotal"
          })
          .then(res => {
            common.Response.callNotMsgResponse(res, function(result) {
              //console.log(result);
              that.viewModel = result;
            });
          });
      },
      goBack() {
        this.$router.go(-1);
      },
      formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      },
      onConfirm(date) {
        const [start, end] = date;
        this.jifenDateShow = false;
        this.date = `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
        this.beginTime=this.formatDate(start);
        this.endTime=this.formatDate(end);
      }
    },
    created() {
      this.init();
    }
  };
  </script>
  <style lang="less" scoped>
  .jifenDetailPage {
    padding-bottom: 10px;
  }
  .selectdate-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 12px;
    display: flex;
    align-items: center;
    .lable-box {
      display: flex;
      align-items: center;
      .icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
        margin-right: 10px;
      }
      .title {
        font-size: 16px;
        color: #333;
      }
    }
    .input-control {
      flex: 1;
      overflow: hidden;
      text-align: right;
      font-size: 14px;
      color: #333;
      margin-right: 8px;
    }
  }
  .tongji-section {
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .col {
      width: 32%;
      background: #fff;
      border-radius: 8px;
      padding: 15px 6px;
      height: 100px;
      .tongji-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        .price-box {
          font-size: 12px;
          color: #2b2b2b;
          .price {
            font-size: 22px;
            font-weight: bold;
          }
        }
        .des {
          font-size: 14px;
          color: #7c7c7c;
        }
      }
    }
  }
  .jifen-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 0;
  }
  //积分item
  .jifen-item {
    margin: 10px;
    background: #fff;
    padding: 0 14px;
    border-radius: 6px;
    overflow: hidden;
    box-sizing: border-box;
    .thead {
      display: flex;
      align-items: center;
      padding: 10px 0;
      .thead-left {
        flex: 1;
        overflow: hidden;
        display: flex;
        align-items: center;
        .avatar {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 8px;
        }
        .name {
          font-size: 13px;
          color: #3d3c3c;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .thead-right {
        margin-left: 15px;
        flex: 1;
        overflow: hidden;
        text-align: right;
        font-size: 12px;
        color: #ababab;
        .grade {
          color: #3d3c3c;
        }
      }
    }
    .tbody {
      display: flex;
      align-items: center;
      padding: 12px 0 15px;
      .th {
        margin-right: 15px;
        .thumb {
          width: 58px;
          height: 58px;
          object-fit: cover;
          border-radius: 4px;
        }
      }
      .bd {
        flex: 1;
        overflow: hidden;
        .one-line {
          display: flex;
          align-items: center;
          overflow: hidden;
          margin-bottom: 6px;
          .goods-name {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #000000;
          }
          .price {
            margin-left: 15px;
            font-size: 14px;
            color: #000000;
            font-family: Arial, Helvetica, sans-serif;
          }
        }
        .two-line {
          display: flex;
          align-items: center;
          overflow: hidden;
          .date {
            flex: 1;
            overflow: hidden;
            font-size: 12px;
            color: #b7b7b7;
          }
          .num {
            font-size: 10px;
            color: #b7b7b7;
            margin-left: 15px;
          }
        }
        .three-line {
          margin-top: 3px;
          display: flex;
          align-items: center;
          .jifen {
            flex: 1;
            overflow: hidden;
            font-size: 10px;
            color: #000;
            .hlight {
              color: #ff375b;
              font-size: 13px;
            }
          }
          .show-btn {
            margin-left: 15px;
            line-height: 1;
            font-size: 12px;
            padding: 4px 8px;
            border: 1px solid;
            color: #464646;
            border-radius: 999px;
          }
        }
      }
    }
  }
  </style>
  